import $ from "../libs/jquery-3.3.1.min.js"
import {BaseGameLimno} from "/js/app/base/BaseGameLimno";
import {AudioPlaylist} from '/js/app/base/AudioPlaylist.js'
import {gsap} from "../libs/gsap/all.js"
import {Howl} from "howler";
import {Avatar} from "./components/Avatar";

// Constructor
export class Outro extends BaseGameLimno {

  constructor(topicId) {

    // Super constructor
    super("data/outro.json", "LIMNO/STATION" + topicId);
    this.screensaverDelay = 45;

    this.playlist = new AudioPlaylist();

    this.currentTimeline = null;
    this.cloudFloatingTimeline = null;
  }

  // To be overriden in child games
  initGame() {

    super.initGame();

    this.avatar.setFloating(true);

    this.cloudAvatar = new Avatar("#cloud-avatar");

    // if (inElectron()) {
    //   this.playAudioAmbiance()
    // } else {
    //   $(window).one('click', this.playAudioAmbiance());
    // }

    // Go to first screen
    // if (inElectron()) {
    // this.initScreenSaver();
    // this.goToScreen(1);
    // } else {
    // 	$("#first-click-interact").one(this.touchEvent, $.proxy(this.initScreenSaver, this));
    // 	this.goToScreen("first-click-interact");
    // }

    // this.i18n.set("fr");

  };

  // To be overriden in child games
  initScreen(screenId) {

    // Super constructor
    if (super.initScreen(screenId) === false) {
      return false;
    }

    switch (screenId) {
      case 1:
        break;
      case 2:
        this.animateScreen2();
        break;
    }
  }

  // To be overriden in child games
  onMessage(e) {
    const type = e.type;
    const visitorData = e.visitorData;
    console.log("message received : ", type, visitorData);

    this.resetTimer();

    if (this.stillThereTimeout != false) {
      this.closeStillThereModal();
      // this.initScreenAudio(this.currentScreen);
      return;
    }

    // In all time, reset on tag remove
    if (type === "tagRemove") {
      this.reset(1);
    }

    // On screen 1, load data on tag drop
    if (this.currentScreen === 1 && type === "tagDrop") {
      if (this.currentVisitorHasCompletedRegistration()) {

        // Handle emotion custom properties
        const emotion = this.currentVisitorData.records.EMOTION.toString().toLowerCase();
        if (["happy", "laughing", "surprised"].includes(emotion)) {
          $("#screen-2 .cloud").removeClass("happy laughing surprised").addClass(emotion)
          this.cloudAvatar.setAvatar(emotion, true)
        } else {
          console.error(`Given emotion is not valid (${emotion}).`)
        }

        this.initVisitor().then(() => {
          this.goToScreen(2);
        });
      } else {
        console.log("Visitor has not completed registration, ignoring scan.");
      }
    }
  }

  animateScreen2() {
    this.currentTimeline = gsap.timeline();
    const duration = 2.5;

    this.currentTimeline.set($(`#cloud`), {autoAlpha: 1});
    this.currentTimeline.add(() => $("#countdown-arrow").addClass("disabled"))

    this.currentTimeline.fromTo($(`#avatar`), {
      y: 100,
      x: 0,
    }, {
      y: 0,
      autoAlpha: 1,
      duration: 0.5,
      delay: 0.5
    });

    this.currentTimeline.to($(`#wallpaper`), {
      y: 1080,
      duration: duration,
      ease: "power1.inOut",
    });

    this.currentTimeline.to($(`#avatar`), {
      y: -150,
      scale: 0.3,
      duration: duration,
      ease: "power1.inOut",
    }, '<');

    this.currentTimeline.fromTo($(`#cloud`), {
      y: -1080,
    }, {
      y: 0,
      duration: duration,
      ease: "power1.inOut",
    }, '<');

    this.currentTimeline.fromTo($(`#cloud-avatar`), {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      duration: 1,
      ease: "power1.inOut",
    }, "-=0.5");

    this.currentTimeline.to($(`#avatar`), {
      autoAlpha: 0,
      duration: 1,
    }, 2.5);

    this.currentTimeline.fromTo($(`#screen-2 .infos`), {
      x: 960,
    }, {
      x: 0,
      duration: 3,
      ease: "power1.out",
    }, "+=1.0");

    this.currentTimeline.fromTo($(`#countdown-arrow`), {
      x: 960,
      autoAlpha: 0,
    }, {
      x: 0,
      autoAlpha: 1,
      duration: 1.5,
      ease: "power1.out",
    }, "<");

    this.currentTimeline.fromTo("#countdown", {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      duration: 1.5,
    }, "<");

    // this.currentTimeline.add(() => this.sendLedMessage(), "<")
    this.currentTimeline.add(() => this.playNarration(this.data.content.screen2.audio), "<")

    const risingDrop = gsap.timeline({
      repeat: -1,
      repeatDelay: 1,
    });
    risingDrop.fromTo("#rising-drop", {
      y: 1080,
      scale: 1,
    }, {
      y: 0,
      scale: 0.5,
      duration: 3,
    })
    this.currentTimeline.add(risingDrop)

    const countdownDuration = this.settings.outro.countdown;
    const timerDrop = gsap.timeline();
    for (let i = countdownDuration; i >= 0; i--) {
      timerDrop.add(() => {
        $("#countdown-text").text(i)
        // this.resetTimer();
      }, countdownDuration - i);
    }
    timerDrop.add(() => this.sendLedMessage())
    timerDrop.add(() => $("#countdown-arrow").removeClass("disabled"))
    timerDrop.to("#countdown", {
      autoAlpha: 0,
      duration: 0.5,
    }, "+=1.0");
    this.currentTimeline.add(timerDrop, 0)


    // this.sendLedMessage();


    // this.currentTimeline.fromTo("#rising-drop", {
    //   y: 1080,
    // }, {
    //   y: 0,)

    this.animateCloudFloating();
  }

  goToScreenSaver() {
    // Super constructor
    // if (super.goToScreenSaver() == false) {
    //   return false;
    // }
    this.reset(1);
  }

  animateCloudFloating() {
    if (this.cloudFloatingTimeline == null) {
      this.cloudFloatingTimeline = new gsap.timeline({repeat: -1});

      this.cloudFloatingTimeline.to("#screen-2 #cloud .inner-wrapper", {
        y: 20,
        duration: 2,
        ease: "power1.inOut",
      });
      this.cloudFloatingTimeline.to("#screen-2 #cloud .inner-wrapper", {
        y: 0,
        duration: 2,
        ease: "power1.inOut",
      })

    } else {
      this.cloudFloatingTimeline.play();
    }
  }

  stopCloudFloating() {
    if (this.cloudFloatingTimeline != null) {
      this.cloudFloatingTimeline.pause();
    }
  }

  reset(screenId) {

    if (this.redirectTimeout != false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    if (this.currentTimeline) {
      this.currentTimeline.kill();
      this.currentTimeline = null;
    }

    let resetCallback = () => {
      // TODO Add things to append after reset here, if required
      gsap.set($(`#avatar`), {
        y: 0,
        x: 0,
        scale: 0.6,
        autoAlpha: 0,
      });
      gsap.set($(`#wallpaper`), {
        y: 0,
      });
      this.stopCloudFloating();
      this.avatar.setAvatar(null);
      this.cloudAvatar.setAvatar(null);
      this.cloudAvatar.stopAllAnimation();
      this.clearTheme();
    }

    // TODO Reset other things here
    this.clearTheme(".themeable:not(#cloud-avatar):not(#cloud):not(#avatar):not(#countdown-arrow)");
    gsap.to($(`#avatar, #cloud`), {
      autoAlpha: 0,
      duration: 0.5,
    });

    if (typeof screenId == "undefined") {
      resetCallback();
    }

    // Super
    if (super.reset(screenId, resetCallback) == false) {
      return false;
    }

  }
}
